if (!customElements.get("component-tabs")) {
  class Tabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabs(
        ".tabs__btn",
        ".tabs__content",
        "show",
        "active",
      )
    }

    tabs(btnSelector, contentSelector, contentActiveClass, btnActiveClass) {
      const tabs = this.querySelectorAll(btnSelector);
      const tabsContent = this.querySelectorAll(contentSelector);

      console.log('init tabs');
      
      function hideTabs() {
        tabsContent.forEach((item) => {
          item.classList.remove(contentActiveClass);
          item.setAttribute("aria-hidden", true);
        });

        tabs.forEach((tab) => {
          tab.classList.remove(contentActiveClass);
          tab.setAttribute("aria-expanded", false);
        });
      }

      function showTabs(i = 0) {
        tabsContent[i].classList.add(contentActiveClass);
        tabsContent[i].setAttribute("aria-hidden", false);
        tabs[i].classList.add(btnActiveClass);
        tabs[i].setAttribute("aria-expanded", true);
      }

      hideTabs();
      showTabs();

      tabs.forEach((tab, i) => {
        tab.addEventListener("click", () => {
          hideTabs();
          showTabs(i);
        });
      });
    }
  }

  customElements.define("component-tabs", Tabs);
}
